import { createContext, useContext, useEffect, useState, useCallback, type ReactNode } from "react";
import { api } from "./api";
import type { Stats } from "./types";

interface StatsContextValue {
  stats: Stats | null;
  refreshStats: () => void;
}

const StatsContext = createContext<StatsContextValue | null>(null);

export function StatsProvider({ children }: { children: ReactNode }) {
  const [stats, setStats] = useState<Stats | null>(null);

  const fetchStats = useCallback(() => {
    api.get<Stats>("/stats").then((res) => {
      if (res.ok) setStats(res.data);
    });
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <StatsContext.Provider value={{ stats, refreshStats: fetchStats }}>
      {children}
    </StatsContext.Provider>
  );
}

export function useStats(): StatsContextValue {
  const ctx = useContext(StatsContext);
  if (!ctx) throw new Error("useStats must be used within StatsProvider");
  return ctx;
}
